import React from "react";

import AppOnboardingRequests from "../../HoyerPay/AppOnboardingRequests";

const HoyerPayRequests = ({ ...props }) => {
    return <AppOnboardingRequests />;
};

export default HoyerPayRequests;
